// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9aed7d1e","453":"77e2fe35"}[chunkId] + ".chunk.js";
};